import { render, staticRenderFns } from "./currencyHistory.vue?vue&type=template&id=6775b031&scoped=true&"
import script from "./currencyHistory.vue?vue&type=script&lang=js&"
export * from "./currencyHistory.vue?vue&type=script&lang=js&"
import style0 from "./currencyHistory.vue?vue&type=style&index=0&id=6775b031&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6775b031",
  null
  
)

export default component.exports